import './applied_filter_view.js.coffee';# Added by Script 
Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.AppliedRatingView extends
      Monitoring.Views.SocialContents.Filters.AppliedFilterView
  name: 'star_ratings'
  humanize: true
  unmodifiableByModerators: false

  initialize: ({searchQuery}) ->
    super({searchQuery: searchQuery})
    @alias = I18n.t('monitoring.dashboard.filters.rating')

  removeFilter: (value) ->
    @searchQuery.removeStarRatings(value)

  getDescription: (rating) ->
    suffix = if rating > 1 then 's' else ''
    return "#{rating} #{I18n.t('monitoring.dashboard.filters.stars', {suffix: suffix})}"
